// const ON_CHANGE_DEBOUNCE_TIMER = 300;
// const PUB_SUB_EVENTS = {
// 	cartUpdate: "cart-update",
// 	quantityUpdate: "quantity-update",
// 	variantChange: "variant-change",
// 	cartError: "cart-error",
// };
// const routes = {
// 	cart_add_url: "/cart/add",
// 	cart_change_url: "/cart/change",
// 	cart_update_url: "/cart/update",
// 	cart_url: "/cart",
// 	predictive_search_url: "/search/suggest",
// };
// function debounce(fn, wait) {
// 	let t;
// 	return (...args) => {
// 		clearTimeout(t);
// 		t = setTimeout(() => fn.apply(this, args), wait);
// 	};
// }
// let subscribers = {};
// function subscribe(eventName, callback) {
// 	if (subscribers[eventName] === undefined) {
// 		subscribers[eventName] = [];
// 	}

// 	subscribers[eventName] = [...subscribers[eventName], callback];

// 	return function unsubscribe() {
// 		subscribers[eventName] = subscribers[eventName].filter((cb) => {
// 			return cb !== callback;
// 		});
// 	};
// }
// function publish(eventName, data) {
// 	if (subscribers[eventName]) {
// 		subscribers[eventName].forEach((callback) => {
// 			callback(data);
// 		});
// 	}
// }
// function fetchConfig(type = "json") {
// 	return {
// 		method: "POST",
// 		headers: { "Content-Type": "application/json", Accept: `application/${type}` },
// 	};
// }
// class CartDrawer extends HTMLElement {
// 	constructor() {
// 		super();

// 		this.cartOpen = document.querySelectorAll("[toggle-cart]");
// 		this.cartClose = document.querySelectorAll(".cart-popup-backdrop, .cart-popup__close");
// 	}

// 	open() {
// 		this.querySelector(".cart-popup-backdrop").classList.remove("hidden");
// 		this.classList.remove("cart-popup-wrapper--hidden");
// 	}

// 	close() {
// 		this.querySelector(".cart-popup-backdrop").classList.add("hidden");
// 		this.classList.add("cart-popup-wrapper--hidden");
// 	}

// 	getSectionInnerHTML(html, selector) {
// 		return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
// 	}

// 	getSectionsToRender() {
// 		return [
// 			{ id: "CartDrawer", section: "cart-popup", selector: ".drawer__content" },
// 			{
// 				id: "cartItemCountCart",
// 				section: "cart-popup",
// 				selector: "#cartItemCountCart",
// 			},
// 			{
// 				id: "cartItemCount",
// 				section: "header",
// 				selector: "#cartItemCount",
// 			},
// 		];
// 	}

// 	renderContents(parsedState) {
// 		this.getSectionsToRender().forEach((section) => {
// 			const sectionElement = section.selector
// 				? document.querySelector(section.selector)
// 				: document.getElementById(section.id);

// 			sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
// 		});

// 		this.open();
// 	}

// 	connectedCallback() {
// 		this.cartOpen.forEach((element) => {
// 			element.addEventListener("click", this.open.bind(this));
// 		});
// 		this.cartClose.forEach((element) => {
// 			element.addEventListener("click", this.close.bind(this));
// 		});
// 	}
// }
// customElements.define("cart-drawer", CartDrawer);

// class CartRemoveButton extends HTMLElement {
// 	constructor() {
// 		super();

// 		this.addEventListener("click", (event) => {
// 			event.preventDefault();
// 			const cartItems = document.querySelector("cart-items");
// 			const index = this.dataset.index;
// 			cartItems.updateQuantity(index, 0);
// 		});
// 	}
// }

// customElements.define("cart-remove-button", CartRemoveButton);

// class CartItems extends HTMLElement {
// 	constructor() {
// 		super();
// 		this.lineItemStatusElement =
// 			document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");

// 		const debouncedOnChange = debounce((event) => {
// 			this.onChange(event);
// 		}, ON_CHANGE_DEBOUNCE_TIMER);

// 		this.addEventListener("change", debouncedOnChange.bind(this));
// 	}

// 	cartUpdateUnsubscriber = undefined;

// 	connectedCallback() {
// 		this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
// 			if (event.source === "cart-items") {
// 				return;
// 			}
// 			this.onCartUpdate();
// 		});
// 	}

// 	disconnectedCallback() {
// 		if (this.cartUpdateUnsubscriber) {
// 			this.cartUpdateUnsubscriber();
// 		}
// 	}

// 	onChange(event) {
// 		if (event.target.type === "select-one") {
// 			return;
// 		}
// 		const index = event.target.dataset.index;
// 		this.updateQuantity(index, event.target.value, event.target.dataset.quantityVariantId);
// 	}

// 	onCartUpdate() {
// 		fetch(`${routes.cart_url}?section_id=cart-drawer`)
// 			.then((response) => response.text())
// 			.then((responseText) => {
// 				const html = new DOMParser().parseFromString(responseText, "text/html");
// 				const selectors = ["cart-drawer-items"];
// 				for (const selector of selectors) {
// 					const targetElement = document.querySelector(selector);
// 					const sourceElement = html.querySelector(selector);
// 					if (targetElement && sourceElement) {
// 						targetElement.replaceWith(sourceElement);
// 					}
// 				}
// 			})
// 			.catch((e) => {
// 				console.error(e);
// 			});
// 	}

// 	updateQuantity(line, quantity, quantityElementLines) {
// 		return new Promise((resolve, reject) => {
// 		this.enableLoading(line);

// 		const request = {
// 			url: routes.cart_change_url,
// 			data: { line, quantity },
// 		};

// 		const { url, data } = request;

// 		const body = JSON.stringify({
// 			...data,
// 			sections: this.getSectionsToRender().map((section) => section.section),
// 			sections_url: window.location.pathname,
// 		});

// 		fetch(`${url}`, { ...fetchConfig(), ...{ body } })
// 			.then((response) => {
// 				return response.text();
// 			})
// 			.then((state) => {
// 				const parsedState = JSON.parse(state);
// 				const quantityElement =
// 					document.getElementById(`Quantity-${quantityElementLines}`) ||
// 					document.getElementById(`Drawer-quantity-${quantityElementLines}`);

// 				if (parsedState.errors) {
// 					quantityElement.value = quantityElement.getAttribute("value");
// 					return;
// 				}

// 				this.classList.toggle("is-empty", parsedState.item_count === 0);
// 				const cartDrawerWrapper = document.querySelector("cart-drawer");

// 				if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);

// 				this.getSectionsToRender().forEach((section) => {
// 					const elementToReplace =
// 						document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
// 					elementToReplace.innerHTML = this.getSectionInnerHTML(
// 						parsedState.sections[section.section],
// 						section.selector
// 					);
// 				});

// 				publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items", cartData: parsedState, variantId: line });
// 				resolve();
// 			})
// 			.catch((err) => {
// 				console.log(err);
// 				reject(err);
// 			})
// 			.finally(() => {
// 				this.disableLoading(line);
// 			});
// 		});
// 	}

// 	getSectionInnerHTML(html, selector) {
// 		return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
// 	}

// 	enableLoading(line) {
// 		const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
// 		mainCartItems.classList.add("cart__items--disabled");

// 		const cartDrawerItemElement = this.querySelector(`[id="CartDrawer-Item-${line}"]`);
// 		cartDrawerItemElement.classList.add("loading");

// 		document.activeElement.blur();
// 		this.lineItemStatusElement.setAttribute("aria-hidden", false);
// 	}

// 	disableLoading(line) {
// 		const cartDrawerItemElement = this.querySelector(`[id="CartDrawer-Item-${line}"]`);
// 		cartDrawerItemElement.classList.remove("loading");
// 	}

// 	getSectionsToRender() {
// 		const cartTarget = {
// 			id: "CartDrawer",
// 			section: "cart-popup",
// 		};
// 		return [
// 			{
// 				...cartTarget,
// 				selector: ".drawer__content",
// 			},
// 			{
// 				id: "cartItemCountCart",
// 				section: "cart-popup",
// 				selector: "#cartItemCountCart",
// 			},
// 			{
// 				id: "cartItemCount",
// 				section: "header",
// 				selector: "#cartItemCount",
// 			},
// 		];
// 	}
// }

// customElements.define("cart-items", CartItems);

// class QuantityInput extends HTMLElement {
// 	constructor() {
// 		super();
// 		this.input = this.querySelector("input");
// 		this.changeEvent = new Event("change", { bubbles: true });
// 		this.input.addEventListener("change", this.onInputChange.bind(this));
// 		this.querySelectorAll("button").forEach((button) =>
// 			button.addEventListener("click", this.onButtonClick.bind(this))
// 		);
// 	}

// 	quantityUpdateUnsubscriber = undefined;

// 	connectedCallback() {
// 		this.validateQtyRules();
// 		this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
// 	}

// 	disconnectedCallback() {
// 		if (this.quantityUpdateUnsubscriber) {
// 			this.quantityUpdateUnsubscriber();
// 		}
// 	}

// 	onInputChange() {
// 		this.validateQtyRules();
// 	}

// 	onButtonClick(event) {
// 		event.preventDefault();
// 		const previousValue = this.input.value;

// 		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
// 		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
// 	}

// 	validateQtyRules() {
// 		const value = parseInt(this.input.value);
// 		if (this.input.min) {
// 			const min = parseInt(this.input.min);
// 			const buttonMinus = this.querySelector(".quantity__button[name='minus']");
// 			buttonMinus.classList.toggle("disabled", value <= min);
// 		}
// 		if (this.input.max) {
// 			const max = parseInt(this.input.max);
// 			const buttonPlus = this.querySelector(".quantity__button[name='plus']");
// 			buttonPlus.classList.toggle("disabled", value >= max);
// 		}
// 	}
// }

// customElements.define("quantity-input", QuantityInput);

// class GiftWrap extends HTMLElement {
// 	constructor() {
// 		super();
// 		this.addEventListener("change", this.changeHandler.bind(this));
// 	}
// 	removeItem() {
// 		const itemToRemove = document.querySelector(".gift-wrap-item cart-remove-button");
// 		itemToRemove?.click();
// 	}

// 	changeHandler(event) {
// 		event.preventDefault();

// 		if (!event.target.checked) {
// 			this.removeItem();
// 		} else {
// 			this.querySelector("product-form button").click();
// 		}
// 	}
// }

// customElements.define("gift-wrap", GiftWrap);

// class Bundle extends HTMLElement {
// 	constructor() {
// 		super();
// 		this.addEventListener("submit", this.changeHandler.bind(this));
// 	}

// 	async changeHandler(event) {
// 		event.preventDefault();
// 		const itemsToRemove = this.dataset.bundle;
// 		await new Promise(resolve => setTimeout(async () => {
// 			const upsellToRemoveElements = document.querySelectorAll(`.${itemsToRemove}`);
// 			for (const iterator of upsellToRemoveElements) {
// 				const cartItems = document.querySelector("cart-items");
// 				const input = document.querySelector(`.${itemsToRemove}#${iterator.id} input`);
// 				await cartItems.updateQuantity(input.dataset.index, input.value - 1);
// 			}
// 			resolve();
// 		}, 1500));
// 	}
// }

// customElements.define("bundle-wrap", Bundle);

// class CartNote extends HTMLElement {
// 	constructor() {
// 		super();
// 		this.textarea = this.querySelector("textarea");
// 		this.textarea?.addEventListener("focusout", this.updateNote.bind(this));
// 		const checkbox = this.querySelector("input");
// 		checkbox?.addEventListener("change", this.updateNote.bind(this));
// 	}

// 	updateNote(event) {
// 		event.preventDefault();

// 		let value = "";
// 		if (event.target.type === "checkbox") {
// 			if (event.target.checked) return;
// 			else this.textarea.value = "";
// 		} else {
// 			value = event.target.value;
// 		}

// 		fetch("/cart/update.json", {
// 			method: "POST",
// 			headers: {
// 				"Content-Type": "application/json",
// 				Accept: "application/json",
// 			},
// 			body: JSON.stringify({
// 				attributes: {
// 					"gift-note": value,
// 				},
// 			}),
// 		});
// 	}
// }

// customElements.define("cart-note", CartNote);






























/**************New */
// const ON_CHANGE_DEBOUNCE_TIMER = 300;
// const PUB_SUB_EVENTS = {
// 	cartUpdate: "cart-update",
// 	quantityUpdate: "quantity-update",
// 	variantChange: "variant-change",
// 	cartError: "cart-error",
// };
// const routes = {
// 	cart_add_url: "/cart/add",
// 	cart_change_url: "/cart/change",
// 	cart_update_url: "/cart/update",
// 	cart_url: "/cart",
// 	predictive_search_url: "/search/suggest",
// };
// function debounce(fn, wait) {
// 	let t;
// 	return (...args) => {
// 		clearTimeout(t);
// 		t = setTimeout(() => fn.apply(this, args), wait);
// 	};
// }
// let subscribers = {};
// function subscribe(eventName, callback) {
// 	if (subscribers[eventName] === undefined) {
// 		subscribers[eventName] = [];
// 	}

// 	subscribers[eventName] = [...subscribers[eventName], callback];

// 	return function unsubscribe() {
// 		subscribers[eventName] = subscribers[eventName].filter((cb) => {
// 			return cb !== callback;
// 		});
// 	};
// }
// function publish(eventName, data) {
// 	if (subscribers[eventName]) {
// 		subscribers[eventName].forEach((callback) => {
// 			callback(data);
// 		});
// 	}
// }
// function fetchConfig(type = "json") {
// 	return {
// 		method: "POST",
// 		headers: { "Content-Type": "application/json", Accept: `application/${type}` },
// 	};
// }
// class CartDrawer extends HTMLElement {
// 	constructor() {
// 		super();

// 		this.cartOpen = document.querySelectorAll("[toggle-cart]");
// 		this.cartClose = document.querySelectorAll(".cart-popup-backdrop, .cart-popup__close");
// 	}

// 	open() {
// 		this.querySelector(".cart-popup-backdrop").classList.remove("hidden");
// 		this.classList.remove("cart-popup-wrapper--hidden");
// 	}

// 	close() {
// 		this.querySelector(".cart-popup-backdrop").classList.add("hidden");
// 		this.classList.add("cart-popup-wrapper--hidden");
// 	}

// 	getSectionInnerHTML(html, selector) {
// 		return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
// 	}

// 	getSectionsToRender() {
// 		return [
// 			{ id: "CartDrawer", section: "cart-popup", selector: ".drawer__content" },
// 			{
// 				id: "cartItemCountCart",
// 				section: "cart-popup",
// 				selector: "#cartItemCountCart",
// 			},
// 			{
// 				id: "cartItemCount",
// 				section: "header",
// 				selector: "#cartItemCount",
// 			},
// 		];
// 	}

// 	renderContents(parsedState) {
// 		this.getSectionsToRender().forEach((section) => {
// 			const sectionElement = section.selector
// 				? document.querySelector(section.selector)
// 				: document.getElementById(section.id);

// 			sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
// 		});

// 		this.open();
// 	}

// 	connectedCallback() {
// 		this.cartOpen.forEach((element) => {
// 			element.addEventListener("click", this.open.bind(this));
// 		});
// 		this.cartClose.forEach((element) => {
// 			element.addEventListener("click", this.close.bind(this));
// 		});
// 	}
// }
// customElements.define("cart-drawer", CartDrawer);

// class CartRemoveButton extends HTMLElement {
// 	constructor() {
// 		super();

// 		this.addEventListener("click", (event) => {
// 			event.preventDefault();
// 			const cartItems = document.querySelector("cart-items");
// 			const index = this.dataset.index;
// 			cartItems.updateQuantity(index, 0);
// 		});
// 	}
// }

// customElements.define("cart-remove-button", CartRemoveButton);

// class CartItems extends HTMLElement {
// 	constructor() {
// 		super();
// 		this.lineItemStatusElement =
// 			document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");

// 		const debouncedOnChange = debounce((event) => {
// 			this.onChange(event);
// 		}, ON_CHANGE_DEBOUNCE_TIMER);

// 		this.addEventListener("change", debouncedOnChange.bind(this));
// 	}

// 	cartUpdateUnsubscriber = undefined;

// 	connectedCallback() {
// 		this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
// 			if (event.source === "cart-items") {
// 				return;
// 			}
// 			this.onCartUpdate();
// 		});
// 	}

// 	disconnectedCallback() {
// 		if (this.cartUpdateUnsubscriber) {
// 			this.cartUpdateUnsubscriber();
// 		}
// 	}

// 	onChange(event) {
// 		if (event.target.type === "select-one") {
// 			return;
// 		}
// 		const index = event.target.dataset.index;
// 		this.updateQuantity(index, event.target.value, event.target.dataset.quantityVariantId);
// 	}

// 	onCartUpdate() {
// 		// fetch(`${routes.cart_url}?section_id=cart-drawer`)
// 		fetch(`${routes.cart_url}?section_id=cart-popup`)
// 			.then((response) => response.text())
// 			.then((responseText) => {
// 				const html = new DOMParser().parseFromString(responseText, "text/html");
// 				const selectors = ["cart-drawer-items"];
// 				for (const selector of selectors) {
// 					const targetElement = document.querySelector(selector);
// 					const sourceElement = html.querySelector(selector);
// 					if (targetElement && sourceElement) {
// 						targetElement.replaceWith(sourceElement);
// 					}
// 				}
// 			})
// 			.catch((e) => {
// 				console.error(e);
// 			});
// 	}

// 	updateQuantity(line, quantity, quantityElementLines) {
// 		return new Promise((resolve, reject) => {
// 		this.enableLoading(line);

// 		const request = {
// 			url: routes.cart_change_url,
// 			data: { line, quantity },
// 		};

// 		const { url, data } = request;

// 		const body = JSON.stringify({
// 			...data,
// 			sections: this.getSectionsToRender().map((section) => section.section),
// 			sections_url: window.location.pathname,
// 		});

// 		fetch(`${url}`, { ...fetchConfig(), ...{ body } })
// 			.then((response) => {
// 				return response.text();
// 			})
// 			.then((state) => {
// 				const parsedState = JSON.parse(state);
// 				const quantityElement =
// 					document.getElementById(`Quantity-${quantityElementLines}`) ||
// 					document.getElementById(`Drawer-quantity-${quantityElementLines}`);

// 				if (parsedState.errors) {
// 					quantityElement.value = quantityElement.getAttribute("value");
// 					return;
// 				}

// 				this.classList.toggle("is-empty", parsedState.item_count === 0);
// 				const cartDrawerWrapper = document.querySelector("cart-drawer");

// 				if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);

// 				this.getSectionsToRender().forEach((section) => {
// 					const elementToReplace =
// 						document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
// 					elementToReplace.innerHTML = this.getSectionInnerHTML(
// 						parsedState.sections[section.section],
// 						section.selector
// 					);
// 				});

// 				publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items", cartData: parsedState, variantId: line });
// 				resolve();
// 			})
// 			.catch((err) => {
// 				console.log(err);
// 				reject(err);
// 			})
// 			.finally(() => {
// 				this.disableLoading(line);
// 			});
// 		});
// 	}

// 	getSectionInnerHTML(html, selector) {
// 		return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
// 	}

// 	enableLoading(line) {
// 		const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
// 		mainCartItems.classList.add("cart__items--disabled");

// 		const cartDrawerItemElement = this.querySelector(`[id="CartDrawer-Item-${line}"]`);
// 		cartDrawerItemElement.classList.add("loading");

// 		document.activeElement.blur();
// 		this.lineItemStatusElement.setAttribute("aria-hidden", false);
// 	}

// 	disableLoading(line) {
// 		const cartDrawerItemElement = this.querySelector(`[id="CartDrawer-Item-${line}"]`);
// 		cartDrawerItemElement.classList.remove("loading");
// 	}

// 	getSectionsToRender() {
// 		const cartTarget = {
// 			id: "CartDrawer",
// 			section: "cart-popup",
// 		};
// 		return [
// 			{
// 				...cartTarget,
// 				selector: ".drawer__content",
// 			},
// 			{
// 				id: "cartItemCountCart",
// 				section: "cart-popup",
// 				selector: "#cartItemCountCart",
// 			},
// 			{
// 				id: "cartItemCount",
// 				section: "header",
// 				selector: "#cartItemCount",
// 			},
// 		];
// 	}
// }

// customElements.define("cart-items", CartItems);

// class QuantityInput extends HTMLElement {
// 	constructor() {
// 		super();
// 		this.input = this.querySelector("input");
// 		this.changeEvent = new Event("change", { bubbles: true });
// 		this.input.addEventListener("change", this.onInputChange.bind(this));
// 		this.querySelectorAll("button").forEach((button) =>
// 			button.addEventListener("click", this.onButtonClick.bind(this))
// 		);
// 	}

// 	quantityUpdateUnsubscriber = undefined;

// 	connectedCallback() {
// 		this.validateQtyRules();
// 		this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
// 	}

// 	disconnectedCallback() {
// 		if (this.quantityUpdateUnsubscriber) {
// 			this.quantityUpdateUnsubscriber();
// 		}
// 	}

// 	onInputChange() {
// 		this.validateQtyRules();
// 	}

// 	onButtonClick(event) {
// 		event.preventDefault();
// 		const previousValue = this.input.value;

// 		if (event.target.name === "plus") {
// 			this.input.stepUp();
// 			if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
// 			return;
// 		}

// 		// Minus button: if quantity is already at (or below) 1, clicking it
// 		// again should remove the item entirely instead of trying to go to
// 		// 0 itself. Native stepDown() would silently refuse anyway if
// 		// min="1" is set on the input (that was the original bug — nothing
// 		// happened at all). Instead, find this item's own remove button and
// 		// click it, reusing its exact existing removal behavior rather than
// 		// duplicating that logic here.
// 		if (parseInt(this.input.value) <= 1) {
// 			const itemRow = this.closest(".cart-popup-item");
// 			const removeBtn = itemRow ? itemRow.querySelector("cart-remove-button") : null;
// 			if (removeBtn) {
// 				removeBtn.click();
// 			} else {
// 				// Fallback in case the remove button isn't found for some reason
// 				this.input.value = 0;
// 				this.input.dispatchEvent(this.changeEvent);
// 			}
// 			return;
// 		}

// 		this.input.stepDown();
// 		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
// 	}

// 	validateQtyRules() {
// 		const value = parseInt(this.input.value);
// 		// Minus button is intentionally left enabled even at/below min now —
// 		// clicking it there removes the item (see onButtonClick) instead of
// 		// being a disabled dead click, which was the other half of why
// 		// decreasing to 0 never actually removed the product.
// 		if (this.input.max) {
// 			const max = parseInt(this.input.max);
// 			const buttonPlus = this.querySelector(".quantity__button[name='plus']");
// 			buttonPlus.classList.toggle("disabled", value >= max);
// 		}
// 	}
// }

// customElements.define("quantity-input", QuantityInput);

// class GiftWrap extends HTMLElement {
// 	constructor() {
// 		super();
// 		this.addEventListener("change", this.changeHandler.bind(this));
// 	}
// 	removeItem() {
// 		const itemToRemove = document.querySelector(".gift-wrap-item cart-remove-button");
// 		itemToRemove?.click();
// 	}

// 	changeHandler(event) {
// 		event.preventDefault();

// 		if (!event.target.checked) {
// 			this.removeItem();
// 		} else {
// 			this.querySelector("product-form button").click();
// 		}
// 	}
// }

// customElements.define("gift-wrap", GiftWrap);

// class Bundle extends HTMLElement {
// 	constructor() {
// 		super();
// 		this.addEventListener("submit", this.changeHandler.bind(this));
// 	}

// 	async changeHandler(event) {
// 		event.preventDefault();
// 		const itemsToRemove = this.dataset.bundle;
// 		await new Promise(resolve => setTimeout(async () => {
// 			const upsellToRemoveElements = document.querySelectorAll(`.${itemsToRemove}`);
// 			for (const iterator of upsellToRemoveElements) {
// 				const cartItems = document.querySelector("cart-items");
// 				const input = document.querySelector(`.${itemsToRemove}#${iterator.id} input`);
// 				await cartItems.updateQuantity(input.dataset.index, input.value - 1);
// 			}
// 			resolve();
// 		}, 1500));
// 	}
// }

// customElements.define("bundle-wrap", Bundle);

// class CartNote extends HTMLElement {
// 	constructor() {
// 		super();
// 		this.textarea = this.querySelector("textarea");
// 		this.textarea?.addEventListener("focusout", this.updateNote.bind(this));
// 		const checkbox = this.querySelector("input");
// 		checkbox?.addEventListener("change", this.updateNote.bind(this));
// 	}

// 	updateNote(event) {
// 		event.preventDefault();

// 		let value = "";
// 		if (event.target.type === "checkbox") {
// 			if (event.target.checked) return;
// 			else this.textarea.value = "";
// 		} else {
// 			value = event.target.value;
// 		}

// 		fetch("/cart/update.json", {
// 			method: "POST",
// 			headers: {
// 				"Content-Type": "application/json",
// 				Accept: "application/json",
// 			},
// 			body: JSON.stringify({
// 				attributes: {
// 					"gift-note": value,
// 				},
// 			}),
// 		});
// 	}
// }

// customElements.define("cart-note", CartNote);

const ON_CHANGE_DEBOUNCE_TIMER = 300;
const PUB_SUB_EVENTS = {
	cartUpdate: "cart-update",
	quantityUpdate: "quantity-update",
	variantChange: "variant-change",
	cartError: "cart-error",
};
const routes = {
	cart_add_url: "/cart/add",
	cart_change_url: "/cart/change",
	cart_update_url: "/cart/update",
	cart_url: "/cart",
	predictive_search_url: "/search/suggest",
};
function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}
let subscribers = {};
function subscribe(eventName, callback) {
	if (subscribers[eventName] === undefined) {
		subscribers[eventName] = [];
	}

	subscribers[eventName] = [...subscribers[eventName], callback];

	return function unsubscribe() {
		subscribers[eventName] = subscribers[eventName].filter((cb) => {
			return cb !== callback;
		});
	};
}
function publish(eventName, data) {
	if (subscribers[eventName]) {
		subscribers[eventName].forEach((callback) => {
			callback(data);
		});
	}
}
function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: { "Content-Type": "application/json", Accept: `application/${type}` },
	};
}
class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.cartOpen = document.querySelectorAll("[toggle-cart]");
		this.cartClose = document.querySelectorAll(".cart-popup-backdrop, .cart-popup__close");
	}

	open() {
		this.querySelector(".cart-popup-backdrop").classList.remove("hidden");
		this.classList.remove("cart-popup-wrapper--hidden");
	}

	close() {
		this.querySelector(".cart-popup-backdrop").classList.add("hidden");
		this.classList.add("cart-popup-wrapper--hidden");
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{ id: "CartDrawer", section: "cart-popup", selector: ".drawer__content" },
			{
				id: "cartItemCountCart",
				section: "cart-popup",
				selector: "#cartItemCountCart",
			},
			{
				id: "cartItemCount",
				section: "header",
				selector: "#cartItemCount",
			},
		];
	}

	renderContents(parsedState) {
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);

			sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
		});

		this.open();
	}

	connectedCallback() {
		this.cartOpen.forEach((element) => {
			element.addEventListener("click", this.open.bind(this));
		});
		this.cartClose.forEach((element) => {
			element.addEventListener("click", this.close.bind(this));
		});
	}
}
customElements.define("cart-drawer", CartDrawer);

class CartRemoveButton extends HTMLElement {
	constructor() {
		super();

		this.addEventListener("click", (event) => {
			event.preventDefault();
			const cartItems = document.querySelector("cart-items");
			const index = this.dataset.index;
			cartItems.updateQuantity(index, 0);
		});
	}
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
	constructor() {
		super();
		this.lineItemStatusElement =
			document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");

		const debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, ON_CHANGE_DEBOUNCE_TIMER);

		this.addEventListener("change", debouncedOnChange.bind(this));
	}

	cartUpdateUnsubscriber = undefined;

	connectedCallback() {
		this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
			if (event.source === "cart-items") {
				return;
			}
			this.onCartUpdate();
		});
	}

	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber();
		}
	}

	onChange(event) {
		if (event.target.type === "select-one") {
			return;
		}
		const index = event.target.dataset.index;
		this.updateQuantity(index, event.target.value, event.target.dataset.quantityVariantId);
	}

	onCartUpdate() {
		// fetch(`${routes.cart_url}?section_id=cart-drawer`)
		fetch(`${routes.cart_url}?section_id=cart-popup`)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				const selectors = ["cart-drawer-items"];
				for (const selector of selectors) {
					const targetElement = document.querySelector(selector);
					const sourceElement = html.querySelector(selector);
					if (targetElement && sourceElement) {
						targetElement.replaceWith(sourceElement);
					}
				}
			})
			.catch((e) => {
				console.error(e);
			});
	}

	updateQuantity(line, quantity, quantityElementLines) {
		return new Promise((resolve, reject) => {
		this.enableLoading(line);

		const request = {
			url: routes.cart_change_url,
			data: { line, quantity },
		};

		const { url, data } = request;

		const body = JSON.stringify({
			...data,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		});

		fetch(`${url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);
				const quantityElement =
					document.getElementById(`Quantity-${quantityElementLines}`) ||
					document.getElementById(`Drawer-quantity-${quantityElementLines}`);

				if (parsedState.errors) {
					quantityElement.value = quantityElement.getAttribute("value");
					return;
				}

				this.classList.toggle("is-empty", parsedState.item_count === 0);
				const cartDrawerWrapper = document.querySelector("cart-drawer");

				if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);

				this.getSectionsToRender().forEach((section) => {
					const elementToReplace =
						document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
					elementToReplace.innerHTML = this.getSectionInnerHTML(
						parsedState.sections[section.section],
						section.selector
					);
				});

				publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items", cartData: parsedState, variantId: line });
				resolve();
			})
			.catch((err) => {
				console.log(err);
				reject(err);
			})
			.finally(() => {
				this.disableLoading(line);
			});
		});
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
		mainCartItems.classList.add("cart__items--disabled");

		const cartDrawerItemElement = this.querySelector(`[id="CartDrawer-Item-${line}"]`);
		cartDrawerItemElement.classList.add("loading");

		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute("aria-hidden", false);
	}

	disableLoading(line) {
		const cartDrawerItemElement = this.querySelector(`[id="CartDrawer-Item-${line}"]`);
		cartDrawerItemElement.classList.remove("loading");
	}

	getSectionsToRender() {
		const cartTarget = {
			id: "CartDrawer",
			section: "cart-popup",
		};
		return [
			{
				...cartTarget,
				selector: ".drawer__content",
			},
			{
				id: "cartItemCountCart",
				section: "cart-popup",
				selector: "#cartItemCountCart",
			},
			{
				id: "cartItemCount",
				section: "header",
				selector: "#cartItemCount",
			},
		];
	}
}

customElements.define("cart-items", CartItems);

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });
		this.input.addEventListener("change", this.onInputChange.bind(this));
		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onButtonClick.bind(this))
		);
	}

	quantityUpdateUnsubscriber = undefined;

	connectedCallback() {
		this.validateQtyRules();
		this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
	}

	disconnectedCallback() {
		if (this.quantityUpdateUnsubscriber) {
			this.quantityUpdateUnsubscriber();
		}
	}

	onInputChange() {
		this.validateQtyRules();
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		if (event.target.name === "plus") {
			this.input.stepUp();
			if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
			return;
		}

		// Minus button: if quantity is already at (or below) 1, clicking it
		// again should remove the item entirely instead of trying to go to
		// 0 itself. Native stepDown() would silently refuse anyway if
		// min="1" is set on the input (that was the original bug — nothing
		// happened at all). Instead, find this item's own remove button and
		// click it, reusing its exact existing removal behavior rather than
		// duplicating that logic here.
		if (parseInt(this.input.value) <= 1) {
			const itemRow = this.closest(".cart-popup-item");
			const removeBtn = itemRow ? itemRow.querySelector("cart-remove-button") : null;
			if (removeBtn) {
				removeBtn.click();
			} else {
				// Fallback in case the remove button isn't found for some reason
				this.input.value = 0;
				this.input.dispatchEvent(this.changeEvent);
			}
			return;
		}

		this.input.stepDown();
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
	}

	validateQtyRules() {
		const value = parseInt(this.input.value);
		// Minus button is intentionally left enabled even at/below min now —
		// clicking it there removes the item (see onButtonClick) instead of
		// being a disabled dead click, which was the other half of why
		// decreasing to 0 never actually removed the product.
		if (this.input.max) {
			const max = parseInt(this.input.max);
			const buttonPlus = this.querySelector(".quantity__button[name='plus']");
			buttonPlus.classList.toggle("disabled", value >= max);
		}
	}
}

customElements.define("quantity-input", QuantityInput);

class GiftWrap extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.changeHandler.bind(this));
	}
	removeItem() {
		const itemToRemove = document.querySelector(".gift-wrap-item cart-remove-button");
		itemToRemove?.click();
	}

	changeHandler(event) {
		event.preventDefault();

		if (!event.target.checked) {
			this.removeItem();
		} else {
			this.querySelector("product-form button").click();
		}
	}
}

customElements.define("gift-wrap", GiftWrap);

class Bundle extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("submit", this.changeHandler.bind(this));
	}

	async changeHandler(event) {
		event.preventDefault();
		const itemsToRemove = this.dataset.bundle;
		const bundleProductId = this.dataset.bundleProductId; // this bundle's OWN product id
		await new Promise(resolve => setTimeout(async () => {
			const upsellToRemoveElements = document.querySelectorAll(`.${itemsToRemove}`);
			for (const iterator of upsellToRemoveElements) {
				const cartItems = document.querySelector("cart-items");
				const input = document.querySelector(`.${itemsToRemove}#${iterator.id} input`);
				if (!input) continue;

				// Safety check: never let this remove the bundle's OWN just-added
				// cart row, even if a classname collision or stale/incorrect
				// class assignment somehow makes it match the removal query
				// above. Walks up to the actual cart item row and compares its
				// real product id against this bundle's own product id —
				// skipping the removal if they're the same product.
				const itemRow = input.closest("[data-product-id]");
				if (itemRow && bundleProductId && itemRow.dataset.productId === bundleProductId) {
					continue;
				}

				await cartItems.updateQuantity(input.dataset.index, input.value - 1);
			}
			resolve();
		}, 1500));
	}
}

customElements.define("bundle-wrap", Bundle);

class CartNote extends HTMLElement {
	constructor() {
		super();
		this.textarea = this.querySelector("textarea");
		this.textarea?.addEventListener("focusout", this.updateNote.bind(this));
		const checkbox = this.querySelector("input");
		checkbox?.addEventListener("change", this.updateNote.bind(this));
	}

	updateNote(event) {
		event.preventDefault();

		let value = "";
		if (event.target.type === "checkbox") {
			if (event.target.checked) return;
			else this.textarea.value = "";
		} else {
			value = event.target.value;
		}

		fetch("/cart/update.json", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify({
				attributes: {
					"gift-note": value,
				},
			}),
		});
	}
}

customElements.define("cart-note", CartNote);